import apiClient from "../../api/apiClient";

/**
 * Contact Service
 * Handles all API calls related to contact management
 */

// ================= GET ALL CONTACTS =================
export const getContactsApi = async (
  page: number,
  pageSize: number,
  tenantId: string,
  search: string
) => {
  const res = await apiClient.get("/contacts", {
    params: {
      PageNumber: page,
      PageSize: pageSize,
      TenantId: tenantId,
      Search: search,
      tenantId,
    },
  });

  return res.data;
};

// ================= GET CONTACT BY ID =================
export const getContactByIdApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.get(
    `/contacts/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= CREATE CONTACT =================
export const createContactApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.post(
    "/contacts",
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= UPDATE CONTACT =================
export const updateContactApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.put(
    "/contacts",
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= DELETE CONTACT =================
export const deleteContactApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.delete(
    `/contacts/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= GET UNREAD COUNT =================
export const getUnreadContactCountApi = async (
  tenantId: string
) => {
  const res = await apiClient.get(
    "/contacts/unread-count",
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= MARK CONTACT AS READ =================
export const markContactAsReadApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.put(
    `/contacts/${id}/mark-as-read`,
    {},
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

export const contactService = {
  getContactsApi,
  getContactByIdApi,
  createContactApi,
  updateContactApi,
  deleteContactApi,
  getUnreadContactCountApi,
  markContactAsReadApi
};